import { WidgetProps } from '@rjsf/utils';
import { CircularProgress, IconButton, TextField } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import useOllamaSyncedModels from 'api/prompts-models/useOllamaSyncedModels';

const OllamaBaseUrlWidget = (props: WidgetProps<string>) => {
  const { value, onChange, disabled, readonly, required, schema, rawErrors } = props;
  const { sync } = useOllamaSyncedModels();

  const trimmedValue = (value ?? '').trim();
  const canSync = trimmedValue.length > 0 && !disabled && !readonly && !sync.isPending;

  const handleSync = () => {
    if (!canSync) return;
    sync.mutate(trimmedValue);
  };

  return (
    <div className="flex w-full flex-row items-center gap-2">
      <TextField
        fullWidth
        label={schema.title ?? 'Base URL'}
        placeholder="Base URL for Ollama server"
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value || undefined)}
        disabled={disabled || readonly}
        required={required}
        error={Array.isArray(rawErrors) && rawErrors.length > 0}
      />
      <IconButton
        color="primary"
        onClick={handleSync}
        disabled={!canSync}
        aria-label="Sync Ollama Models"
        type="button"
      >
        {sync.isPending ? <CircularProgress size={16} color="inherit" /> : <CloudDownloadIcon fontSize="small" />}
      </IconButton>
    </div>
  );
};

export default OllamaBaseUrlWidget;
